import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
// import { LoginContext } from '../../../context/LoginContext';
import { useNavigate, useParams } from 'react-router-dom';

const PhonePePayment = () => {

  // const { isLoggedIn, userId, userName, userData } = useContext(LoginContext);
  const [paymentData, setPaymentData] = useState({});
  const param = useParams();


  useEffect(() => {
    const fetchPaymentStatus = async () => {
      try {
        const merchantOrderId = param.id; // Make sure param.id is available
        const response = await axios.get(
          `${process.env.REACT_APP_API_PAYMENT_URL}phonepe/callback?merchantOrderId=${merchantOrderId}`
        );
        setPaymentData(response.data);
      } catch (error) {
        console.error("Error fetching payment status:", error);
      }
    };

    if (param.id) {
      fetchPaymentStatus();
    }
  }, [param.id]);



  return (
    <div>

      <div class="container py-5">
        <div class="row">
          <div class="col-12">
            <div class="card " style={{ overflowX: "auto" }}>
              <table class="table table-bordered table-responsive">
                <thead className='table-head'>
                  <tr>
                    <th>Order Id</th>
                    <th>Payment Mode</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>


                  <tr class="overdue-row">
                    <td>{paymentData?.status?.orderId}</td>
                    <td>
                      
                      {(paymentData?.status?.state == "FAILED") && paymentData?.status?.errorCode}
                      {(paymentData?.status?.state == "COMPLETED") && paymentData?.status?.paymentDetails[0].paymentMode}
                    </td>
                    <td>₹ 
                      {(paymentData?.status?.state == "FAILED") && paymentData?.status?.amount / 100}
                      {(paymentData?.status?.state == "COMPLETED") && paymentData?.status?.paymentDetails[0].amount / 100}
                      </td>
                    <td>
                      {(paymentData?.status?.state == "FAILED") &&
                        (<p class="bg-danger text-white p-1 rounded-2 text-center  ">Failed</p>)}
                      {(paymentData?.status?.state == "COMPLETED") &&
                        (<p class="bg-success text-white p-1 rounded-2 text-center  ">Success</p>)}
                    </td>
                  </tr>


                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default PhonePePayment;
